// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__4nNM8","skeleton_user":"Skeleton_skeleton_user__3-ifI","img":"Skeleton_img__1IGDi","content":"Skeleton_content__9HVMz"};